// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2Howu","topBottomGutter":"Layout_topBottomGutter__36mhm"};